@if (screenSize() === "desktop" || screenSize() === "tablet") {
  <!-- Desktop banner  -->
  <div id="desktop-banner" class="header-row">
    <div class="img-rotated">
      <div>
        <img ngSrc="./assets/SSBA.jpg" alt="SSBA logo" width="75" height="75" priority>
      </div>
      <div>
        <img ngSrc="./assets/SSBA.jpg" alt="SSBA logo" width="75" height="75" priority>
      </div>
    </div>
    <div class="div-margin-left">
      <h1
        class="title"
      >
        {{ screenSize() === "desktop" ? "Security Sensitive Biological Agents Regulatory Scheme" : "SSBA Regulatory Scheme" }}
      </h1>
    </div>

    <div class="header-spacer"></div>

    <div class="login-container">
      <div class="login-header">
        Welcome, {{user()?.firstName}}
        <mat-icon class="icon" aria-hidden="false" aria-label="Home" fontIcon="lock"></mat-icon>
        <div class="header-spacer"></div>
        @if (user()?.facilities?.length && user()?.facilities?.length! > 1) {
          <button id="change-facility-btn" mat-flat-button (click)="chooseFacility.emit()">Change Facility</button>
        }
        <button id="logout-btn" (click)="logout.emit()" type="button"><b>Logout</b></button>
      </div>
      <div class="login-content">
        <p>
          <span class="login-content-title">Facility Registration Number:</span> <span class="login-content-content"> {{activeFacility()?.registrationNumber}}</span>
        </p>
        <p><span class="login-content-title">Facility Name:</span> <span class="login-content-content">{{activeFacility()?.name}}</span></p>
        <p><span class="login-content-title">Facility Registration Status:</span> <span class="login-content-content">{{activeFacility()?.registrationStatus?.value}}</span></p>
        <p><span class="login-content-title">Entity Name:</span> <span class="login-content-content">{{activeFacility()?.entity?.name}}</span></p>
      </div>
    </div>
  </div>
} @else {
  <!-- Mobile banner -->
  <div id="mobile-banner" class="row centre">
    <h1 class="title-mobile">
      SSBA Regulatory Scheme
    </h1>
  </div>
}
